import React from 'react';
import SEOHead, { breadcrumb } from './SEOHead';
import LandingFooter from './LandingFooter';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import './landing.css';

const serif = { fontFamily: '"DM Serif Display", Georgia, serif' };
const ACCENT = '#1a5fff';

const ContactUs = () => {
  return (
    <>
      <SEOHead
        title="Book a Free HRMS Demo — Contact DigiHR"
        description="Book a free 30-minute DigiHR demo tailored to your team size and industry. See GPS attendance, payroll and leave management in action. Call, WhatsApp or email us."
        keywords="HRMS demo, HR software demo India, contact DigiHR, payroll software demo"
        canonical="/contact"
        schema={breadcrumb('Contact', '/contact')}
      />

      <section style={{ padding: '80px 5%' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 60, alignItems: 'start' }} className="contact-grid-resp">

          {/* Left — Contact Info */}
          <div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 500, color: ACCENT, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Get in touch</div>
            <h1 style={{ ...serif, fontSize: 'clamp(28px,3.5vw,42px)', lineHeight: 1.15, letterSpacing: '-.025em', color: '#0d1117', marginBottom: 12 }}>
              Let's get your HR<br /><em style={{ fontStyle: 'italic', color: ACCENT }}>sorted</em>
            </h1>
            <p style={{ fontSize: 15, color: '#3a3f4a', marginBottom: 32, lineHeight: 1.65 }}>Book a free 30-minute demo tailored to your team size and industry. We'll show you exactly how DigiHR fits your workflow.</p>

            <ContactInfo />

            <div style={{ marginTop: 32, padding: '22px 24px', background: '#f6f7f9', borderRadius: 20, border: '1px solid #e4e7ed' }}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>30-day free trial</div>
              <div style={{ fontSize: 13, color: '#717888', lineHeight: 1.6 }}>Book your demo and we'll set up your trial account on the call — usually the same day. No credit card required. Full access to all features. Cancel anytime. Migration assistance included.</div>
            </div>
          </div>

          {/* Right — Form */}
          <ContactForm />
        </div>
      </section>

      <LandingFooter />

      <style>{`@media(max-width:900px){ .contact-grid-resp{ grid-template-columns:1fr !important; } }`}</style>
    </>
  );
};

export default ContactUs;
